<template>
  <div style="display: inline-block;">
    <div class="flex-y-center">
      <div class="col-line"></div>
      <a-button :type="type">
        <slot />
      </a-button>
      <div class="col-line"></div>
    </div>
  </div>
</template>

<script setup>
import { reactive, defineProps } from 'vue'

defineProps({
  type: String
})

const state = reactive({
  color: '#f00'
})

console.log(state)
</script>

<style scoped>
.flex-y-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.col-line {
  width: 1px;
  height: 20px;
  background-color: #eee;
}
</style>
